export default __webpack_public_path__ + "static/media/thankyou.839d6b96.png";